import DOMPurify from 'dompurify';
import { Quill } from 'react-quill-new';
import { normalizeTableTemporary } from './editorContent';

export const initEditorValue = (quillRef: any, html: string) => {
  const editor = quillRef?.current.getEditor();

  const delta = editor.clipboard.convert({
    html: normalizeTableTemporary(html),
  });
  const [range] = editor.selection.getRange();
  editor.updateContents(delta, Quill.sources.USER);
  editor.setSelection(
    delta.length() - (range?.length || 0),
    Quill.sources.SILENT,
  );
  editor.scrollSelectionIntoView();
};

export const sanitizedData = (html: string) => ({
  __html: DOMPurify.sanitize(html),
});

export const getYouTubeVideoId = (url: string) => {
  try {
    const parsedUrl = new URL(url);

    // shorts
    if (
      parsedUrl.hostname.includes('youtube.com') &&
      parsedUrl.pathname.startsWith('/shorts/')
    ) {
      return parsedUrl.pathname.split('/shorts/')[1].split('?')[0];
    }

    return null;
  } catch {
    return null;
  }
};

/* 
  동영상 url 입력 후 save 버튼 클릭시 트리거
  shorts는 지원되는 형식이 아니기 때문에 shorts로 들어오는 url을
  embed url로 변환하여 저장
 */

export const handleTransformYouTubeVideoUrlByClick = (e: MouseEvent) => {
  const target = e.target;
  if (!(target instanceof Element)) {
    return;
  }

  const actionEl = target.closest('.ql-action') as HTMLElement | null;
  if (!actionEl) {
    return;
  }

  const tooltip =
    actionEl.closest('.ql-tooltip') ??
    document.querySelector('.ql-tooltip.ql-editing');

  if (!tooltip) {
    return;
  }

  const input = tooltip.querySelector<HTMLInputElement>('input[type="text"]');

  if (!input || !input.value) {
    return;
  }

  // id 추출 및 변환
  const id = getYouTubeVideoId(input.value);
  if (id) {
    const transformedUrl = `https://www.youtube.com/embed/${id}`;
    input.value = transformedUrl;

    // 새로운 iframe이 추가될 때를 대비한 MutationObserver
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (
              node instanceof HTMLIFrameElement &&
              node.src?.includes('youtube.com/embed')
            ) {
              node.style.width = '100%';
              node.style.aspectRatio = '2 / 1';
              node.style.maxWidth = '100%';
            }
          });
        }
      });
    });

    // 에디터 영역을 관찰
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      observer.observe(editor, { childList: true, subtree: true });
    }

    // 3초 후 observer 해제 (성능 최적화)
    setTimeout(() => {
      observer.disconnect();
    }, 3000);

    // Quill이 변경을 감지하도록 이벤트 트리거
    // input.dispatchEvent(new Event('input', { bubbles: true }));
    // input.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

export const handleTransformYouTubeVideoUrlByEnter = (e: KeyboardEvent) => {
  if (e.key !== 'Enter') return; // Enter가 아니면 무시

  const targetInput: EventTarget | null = document.activeElement;

  if (!(targetInput instanceof HTMLInputElement)) {
    return;
  }

  // id 추출 및 변환
  const id = getYouTubeVideoId(targetInput.value);
  if (id) {
    const transformedUrl = `https://www.youtube.com/embed/${id}`;
    targetInput.value = transformedUrl;

    // 새로운 iframe이 추가될 때를 대비한 MutationObserver
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (
              node instanceof HTMLIFrameElement &&
              node.src?.includes('youtube.com/embed')
            ) {
              node.style.width = '100%';
              node.style.aspectRatio = '2 / 1';
              node.style.maxWidth = '100%';
            }
          });
        }
      });
    });

    // 에디터 영역을 관찰
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      observer.observe(editor, { childList: true, subtree: true });
    }

    // 3초 후 observer 해제 (성능 최적화)
    setTimeout(() => {
      observer.disconnect();
    }, 3000);

    // Quill이 변경을 감지하도록 이벤트 트리거
    // input.dispatchEvent(new Event('input', { bubbles: true }));
    // input.dispatchEvent(new Event('change', { bubbles: true }));
  }
};
